<template>
  <v-alert
    class="mb-3 pa-2"
    :value="true"
    dismissible
    color="primary"
    icon="check_circle"
  >{{ groups.length }} {{ $t('PartsResults.Labels.ItemsFound') }}</v-alert>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'PartsCounter',
  props: {
    groups: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState({
    })
  }
}
</script>